<mat-icon class="mr-3">{{ getIconForValue(formControl.value) }}</mat-icon>
@if (getCaughtObservable(isEnabled) | async) {
  <mat-form-field floatLabel="never">
    <input
      type="text"
      matInput
      [formControl]="formControl"
      [matAutocomplete]="autoGroup"
      autocomplete="off"
    />
    <mat-autocomplete #autoGroup="matAutocomplete" [displayWith]="getIconCaptionToKey">
      @for (group of filteredIcons | async; track group) {
        <mat-optgroup [label]="group.group">
          @for (icon of group.icons; track icon) {
            <mat-option [value]="icon">
              <mat-icon>{{ icon.key }}</mat-icon> {{ icon.caption }}
            </mat-option>
          }
        </mat-optgroup>
      }
    </mat-autocomplete>
  </mat-form-field>
}
@if ((getCaughtObservable(isEnabled) | async) != true) {
  <p>{{ getIconCaptionToKey(formControl.value) }}</p>
}
